<template>
  <div class="box2">
    <div class="demoBox">
      <div class="demo">
        <p>
          180
          <span>天</span>
        </p>
        专业运营讲师监督陪跑
      </div>
      <div class="line"></div>
      <div class="demo">
        <p>
          500
          <span>节</span>
        </p>
        全套体系化短视频课程
      </div>
      <div class="line"></div>
      <div class="demo">
        <p>
          340
          <span>招</span>
        </p>
        可复制化策略/技巧/方法
      </div>
      <div class="line"></div>
      <div class="demo">
        <p>
          3000
          <span>+</span>
        </p>
        优秀毕业学员
      </div>
    </div>
    <img src="../../../assets/coursePage/media/box2/text.png" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box2 {
  position: relative;
  width: 100%;

  overflow: hidden;

  background: RGBA(231, 228, 254, 1);
  box-shadow: 0px 1px 0px 0px #ffffff;
  padding: 40px 0px 40px;
  box-sizing: border-box;

  .demoBox {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    margin-left: 35px;
  }
  .demo {
    width: 324px;
    height: 135px;
    background: #f0eeff;
    border: 1px solid #ffffff;
    border-radius: 8px;
    box-sizing: border-box;
    margin-bottom: 30px;
    margin-right: 30px;
    text-align: center;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #0d004d;
    p {
      height: 40px;
      font-size: 54px;
      font-family: DIN Condensed;
      font-weight: bold;
      color: #2a00ff;
      line-height: 53px;
      margin-top: 28px;
      margin-bottom: 11px;
      span {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #2a00ff;
        line-height: 20px;
        position: relative;
        left: -4px;
        top: -23px;
      }
    }
  }
  .demo:last-child {
    span {
      left: -2px;
      top: -26px;
    }
  }
  img {
    width: 312px;
    display: block;
    margin: 10px auto 0;
  }
}
</style>
